export default __webpack_public_path__ + "../staticImages/hawlogo23-white.png";